export const EVENTS = {
  // Page Views
  PAGE_VIEWED: 'page_viewed',
  AI_REFERRAL_LANDING: 'ai_referral_landing',
  AI_PROVIDER_VIEW: 'ai_provider_view',
  ERROR_PAGE_VIEWED: 'error_page_viewed',
  // Search
  SEARCH_QUERY_SUBMITTED: 'search_query_submitted',
  SEARCH_LOCATION_SELECTED: 'search_location_selected',
  SEARCH_GPS_REQUESTED: 'search_gps_permission_requested',
  SEARCH_CATEGORY_PILL_CLICKED: 'search_category_pill_clicked',
  SEARCH_TRENDING_KEYWORD_CLICKED: 'search_trending_keyword_clicked',
  SEARCH_RESULTS_VIEWED: 'search_results_viewed',
  SEARCH_RESULTS_EMPTY: 'search_results_empty',
  // Discovery
  DISCOVERY_VENDOR_CARD_CLICKED: 'discovery_vendor_card_clicked',
  DISCOVERY_MAP_PIN_CLICKED: 'discovery_map_pin_clicked',
  DISCOVERY_MAP_BOUNDS_CHANGED: 'discovery_map_bounds_changed',
  DISCOVERY_VIEW_TOGGLED: 'discovery_view_toggled',
  DISCOVERY_INFINITE_SCROLL: 'discovery_infinite_scroll_loaded',
  DISCOVERY_CATEGORY_FILTERED: 'discovery_category_filtered',
  DISCOVERY_FILTER_CHANGED: 'discovery_filter_changed',
  // Vendor Profile
  VENDOR_PROFILE_VIEWED: 'vendor_profile_viewed',
  VENDOR_SERVICE_CLICKED: 'vendor_service_clicked',
  VENDOR_CONTACT_CLICKED: 'vendor_contact_clicked',
  VENDOR_SERVICE_DETAIL_VIEWED: 'vendor_service_detail_viewed',
  // Category & Directory
  CATEGORY_PAGE_VIEWED: 'category_page_viewed',
  CATEGORY_CITY_PAGE_VIEWED: 'category_city_page_viewed',
  CATEGORY_PROVINCE_CLICKED: 'category_province_chip_clicked',
  CATEGORY_PAGINATION_USED: 'category_pagination_used',
  CATEGORY_CROSS_LINK_CLICKED: 'category_cross_link_clicked',
  CATEGORY_FAQ_EXPANDED: 'category_faq_expanded',
  DIRECTORY_PAGE_VIEWED: 'directory_page_viewed',
  DIRECTORY_LINK_CLICKED: 'directory_link_clicked',
  DIRECTORY_CLAIM_BUSINESS_CLICKED: 'directory_claim_business_clicked',
  DIRECTORY_NEARBY_VENDOR_CLICKED: 'directory_nearby_vendor_clicked',
  // Homepage
  HOME_CATEGORY_CARD_CLICKED: 'home_category_card_clicked',
  HOME_CTA_CLICKED: 'home_cta_clicked',
  // Auth
  AUTH_SIGN_IN_VIEWED: 'auth_sign_in_viewed',
  AUTH_SIGN_IN_SUBMITTED: 'auth_sign_in_submitted',
  AUTH_SIGN_UP_VIEWED: 'auth_sign_up_viewed',
  AUTH_SIGN_UP_SUBMITTED: 'auth_sign_up_submitted',
  AUTH_LOGGED_OUT: 'auth_logged_out',
  // Onboarding
  ONBOARDING_STARTED: 'onboarding_started',
  ONBOARDING_STEP_COMPLETED: 'onboarding_step_completed',
  ONBOARDING_STEP_BACK: 'onboarding_step_back_clicked',
  ONBOARDING_CANCELLED: 'onboarding_cancelled',
  ONBOARDING_COMPLETED: 'onboarding_completed',
  // Navigation
  NAV_HEADER_SEARCH_OPENED: 'nav_header_search_opened',
  NAV_MOBILE_MENU_OPENED: 'nav_mobile_menu_opened',
  NAV_MOBILE_MENU_LINK_CLICKED: 'nav_mobile_menu_link_clicked',
  NAV_FOOTER_LINK_CLICKED: 'nav_footer_link_clicked',
  NAV_BREADCRUMB_CLICKED: 'nav_breadcrumb_clicked',
  NAV_SOCIAL_LINK_CLICKED: 'nav_social_link_clicked',
  // Engagement
  ENGAGEMENT_SCROLL_DEPTH: 'engagement_scroll_depth',
  ENGAGEMENT_TIME_ON_PAGE: 'engagement_time_on_page',
};
